import React, { useEffect, useState } from 'react';
import { Clear, CollectionAmount, Description, ExtendDays, paymentMethod, PayNow, Reference, Save } from '../../../Constant';
import { Col, Form, FormGroup, Label, Row } from 'reactstrap';
import { useForm } from 'react-hook-form';
import { Btn } from '../../../AbstractElements';
import { getMakePayment, postMakePayment, showPaymentMethod } from '../../../CommonURL';
import Transparentspinner from '../../Common/loader/Transparentspinner';
import { getDataWithToken, postDataWithToken } from '../../../Utils/restUtils';
import { toast } from 'react-toastify';
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

function PaymentFormPopUp({ orderId, setModal,invoiceDetail ,finalTotal,discountAmount  }) {  
  const { register, handleSubmit, formState: { errors } } = useForm({});
  const [loading, setLoading] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const today = new Date().toISOString().split("T")[0];
 const navigate=useNavigate();
useEffect(() => {
  fetchPaymentMethods();
}, []);

const fetchPaymentMethods = async () => {
  setLoading(true);
  const res = await getDataWithToken(showPaymentMethod);

  if (res?.status === true) {
    setPaymentMethods(res.data);  
  } else {
    toast.error("Failed to load payment methods");
  }

  setLoading(false);
};

const onSubmit = async (data) => {
  
    Swal.fire({
      title: `<b>Amount :</b> ${data.amount}`,
      text: "Note : Once the payment is processed, it cannot be reversed, and no changes are allowed.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
      reverseButtons: true
    }).then(async (result) => {

      if (!result.isConfirmed) return;

      setLoading(true);

      const postRequest = {
        order_id: orderId,
        amount: data.amount,
        payment_method: data.payment_method,
        date: data.date,
        reference: data.reference,
        description: data.description,
        discount_amount: discountAmount || 0
      };
           
      const response = await postDataWithToken(postMakePayment, postRequest);
      
      if (response?.data?.message === "payment successful") {
        const paymentID = response.data?.payment_id;
        toast.success(response.data.message);
        navigate(`${process.env.PUBLIC_URL}/billing/thermal-print?payment_id=${paymentID}`);
        setModal(false);
      } else {
        navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
      }

      setLoading(false);
    });
  };


  return (
    <>
      {loading && (
        <Transparentspinner />
      )}
     <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
        <Row className="g-4 ">

          {/* Amount */}
          <Col md="6">
            <Label className="form-label">{CollectionAmount}</Label>
           <input
  className="form-control"
  type="text"
  defaultValue={finalTotal ? finalTotal : invoiceDetail?.order_total}
  readOnly
  {...register("amount")}
/>


          </Col>

          {/* Payment Method (Dropdown) */}
          <Col md="6">
            <Label className="form-label">{paymentMethod} <span className="requireStar">*</span></Label>
            <select className="form-control"
              {...register("payment_method", { required: true })}>
              <option value="">Select Method</option>
              {paymentMethods?.map((item, index) => (
              <option key={index} value={item.name}>
              {item.name}
              </option>
             ))}
            </select>
          </Col>

          {/* Date */}
         <Col md="6">
  <Label className="form-label">Date</Label>
  <input
    className="form-control"
    type="date"
    defaultValue={today}
    {...register("date", { required: true })}
  />
</Col>
          {/* Reference */}
          <Col md="6">
            <Label className="form-label">{Reference}</Label>
            <input
              className="form-control"
              type="text"
              placeholder="Reference No."
              {...register("reference")}
            />
          </Col>

          {/* Description (Textarea) */}
          <Col md="12">
            <Label className="form-label">{Description}</Label>
            <textarea
              className="form-control"
              rows="3"
              placeholder="Enter description"
              {...register("description")}
            ></textarea>
          </Col>

        </Row>

        <FormGroup className="mt-3  text-start">
          <Btn attrBtn={{ color: "primary" }} type="submit">
            {PayNow}
          </Btn>
           <Btn attrBtn={{ className: "ms-2" }}  type="submit">
            {Clear}
          </Btn>
        </FormGroup>
      </Form>
    </>
  )
}

export default PaymentFormPopUp